import axios from 'axios'
import router from '../router';
import { Message } from 'element-ui'
import { getCurrentLine, getDefaultBase } from '@/utils/apiLine'

// IM 普通接口走网关的 im-platform 服务前缀(登录走通用 /user 服务,见 Login.vue;WS 走 /im-server)
const IM_PREFIX = '/im-platform'

const http = axios.create({
	baseURL: getDefaultBase() + IM_PREFIX,
	timeout: 1000 * 30
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	// 运行时线路切换:每个请求按当前选中线路覆盖 baseURL(多域名/最优节点),并带上 im-platform 服务前缀
	config.baseURL = getCurrentLine() + IM_PREFIX;
	// 终端类型 WEB=0(PC 端):后端据此投递离线消息到对应端,与移动端 H5(APP=1)区分
	config.headers.terminal = 0;
	let accessToken = sessionStorage.getItem("accessToken");
	if (accessToken) {
		// config.headers.accessToken = encodeURIComponent(accessToken);
		config.headers.Authorization = (accessToken);
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	if (response.data.code == 200) {
		return response.data.data;
	} else if (response.data.code == 400) {
		return exit();
	} else if (response.data.code == 401) {
		console.log("token失效，尝试重新获取")
		let refreshToken = sessionStorage.getItem("refreshToken");
		if (!refreshToken) {
			return exit()
		}
		// 发送请求, 进行刷新token操作, 获取新的token
		const data = await http({
			method: 'put',
			url: '/refreshToken',
			headers: {
				refreshToken: refreshToken
			}
		}).catch(() => {
			exit();
		})
		// 保存token
		sessionStorage.setItem("accessToken", data.accessToken);
		sessionStorage.setItem("refreshToken", data.refreshToken);
		// 重新发送刚才的请求
		return http(response.config)
	} else {
		Message({
			message: response.data.message,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	switch (error.response.status) {
		case 400:
			Message({
				message: error.response.data,
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 401:
			exit();
			break
		case 405:
			Message({
				message: 'http请求方式有误',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 404:
		case 500:
			Message({
				message: '服务器出了点小差，请稍后再试',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
		case 501:
			Message({
				message: '服务器不支持当前请求所需要的某个功能',
				type: 'error',
				duration: 1500,
				customClass: 'element-error-message-zindex'
			})
			break
	}

	return Promise.reject(error)
})

const exit = () => {
	router.app.$eventBus.$emit("exit")
}


export default http
